import { API_BASE_URL } from './api';
import { authService } from './authService';

export interface Follow {
  followerUserId: string;
  followedUserId: string;
  createdAt: string;
}

export const followService = {
  follow: async (followedUserId: string): Promise<Follow> => {
    const res = await fetch(`${API_BASE_URL}/follows`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authService.getAuthHeaders() },
      body: JSON.stringify({ followedUserId }),
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Failed to follow user');
    }
    return res.json();
  },

  unfollow: async (followedUserId: string): Promise<void> => {
    const res = await fetch(`${API_BASE_URL}/follows/${followedUserId}`, {
      method: 'DELETE',
      headers: { ...authService.getAuthHeaders() },
    });
    if (!res.ok) throw new Error('Failed to unfollow user');
  },

  getFollowers: async (userId: string): Promise<Follow[]> => {
    const res = await fetch(`${API_BASE_URL}/follows/${userId}/followers`);
    if (!res.ok) throw new Error('Failed to load followers');
    return res.json();
  },

  getFollowing: async (userId: string): Promise<Follow[]> => {
    const res = await fetch(`${API_BASE_URL}/follows/${userId}/following`);
    if (!res.ok) throw new Error('Failed to load following');
    return res.json();
  },
};
